import type { ZodType } from "zod";

import { useReferentiallyStableTypedStorage } from "./use-referentially-stable-typed-storage";

export const useTypedLocalStorage = <T>(key: string, schema: ZodType<T>, defaultValue?: T) =>
	useReferentiallyStableTypedStorage<T>(localStorage, key, schema, defaultValue);
